import * as React from "react";

import { BrowserViewer } from "./drivers/browserViewer";
import { ImageViewer } from "./drivers/imageViewer";
import { docViewerUrl } from "./urlFormatter";

const imageTypes = ["image/jpeg", "image/gif", "image/png"];

interface DocViewerProps {
    dataCy?: string;
    docUrl: string;
    docType: string;
    docExtension?: string;
    docKey: string | number;
}

export const DocViewer = React.memo((props: DocViewerProps) => {
    const [viewer, setViewer] = React.useState("browser");
    const [url, setUrl] = React.useState("");

    const { docKey, dataCy } = props;

    React.useEffect(() => {
        setUrl(docViewerUrl(props.docUrl, props.docType, props.docExtension));
        if (imageTypes.indexOf(props.docType) >= 0) {
            setViewer("image");
        } else {
            setViewer("browser");
        }
    }, [props.docExtension, props.docType, props.docUrl]);

    return (
        <div style={{ width: "100%", height: "100%" }}>
            {viewer === "browser" ? (
                <BrowserViewer url={url} key={docKey} dataCy={dataCy} />
            ) : null}
            {viewer === "image" ? (
                <ImageViewer url={url} key={docKey} dataCy={dataCy} />
            ) : null}
        </div>
    );
});
